import { Wrench, Droplets, Zap, Paintbrush, Bolt, HardHat } from "lucide-react";

export const CATEGORIES = [
    {
        slug: "plumbing",
        name: "Plumbing Supplies",
        label: "Plumbing",
        Icon: Droplets,
        image:
            "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg",
        description:
            "PVC & CPVC pipes, elbows, taps, valves, tank fittings and washers for every plumbing job.",
        items: ["PVC / CPVC Pipes", "Taps & Valves", "Tank Fittings", "Washers & Seals"],
        span: "md:col-span-2",
    },
    {
        slug: "electrical",
        name: "Electrical Goods",
        label: "Electrical",
        Icon: Zap,
        image:
            "https://images.unsplash.com/photo-1635335874521-7987db781153?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwd2lyZXMlMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc4MjExMTE1NHww&ixlib=rb-4.1.0&q=85",
        description:
            "Copper wires, modular switches, MCBs, DBs, sockets and LED lighting for homes, shops and sites.",
        items: ["Copper Wires", "Modular Switches", "MCB & DBs", "LED Bulbs & Panels"],
        span: "md:col-span-1",
    },
    {
        slug: "tools",
        name: "Hand & Power Tools",
        label: "Tools",
        Icon: Wrench,
        image:
            "https://images.unsplash.com/reserve/oIpwxeeSPy1cnwYpqJ1w_Dufer%20Collateral%20test.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwdG9vbHMlMjB3cmVuY2glMjBoYW1tZXJ8ZW58MHx8fHwxNzgzMDI4NTc1fDA&ixlib=rb-4.1.0&q=85",
        description:
            "Hammers, drills, wrenches, spanners, cutters and complete tool sets from trusted brands.",
        items: ["Drills & Impact Drivers", "Hammers & Mallets", "Wrenches & Pliers", "Measuring Tape"],
        span: "md:col-span-1",
    },
    {
        slug: "paints",
        name: "Paints & Finishes",
        label: "Paints",
        Icon: Paintbrush,
        image:
            "https://images.pexels.com/photos/9609267/pexels-photo-9609267.jpeg",
        description:
            "Wall paints, primers, enamels, waterproofing coats plus rollers, brushes and thinner.",
        items: ["Interior Emulsion", "Enamel & Primer", "Rollers & Brushes", "Waterproof Coats"],
        span: "md:col-span-1",
    },
    {
        slug: "fasteners",
        name: "Fasteners & Fixings",
        label: "Fasteners",
        Icon: Bolt,
        image:
            "https://images.unsplash.com/photo-1709612840432-2439ce4237e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxzY3Jld3MlMjBib2x0cyUyMG1hY3JvfGVufDB8fHx8MTc4MzU5OTExOXww&ixlib=rb-4.1.0&q=85",
        description:
            "Screws, nuts, bolts, anchors, rawl plugs and rivets in every size you need.",
        items: ["Wood / Metal Screws", "Anchor Bolts", "Rawl Plugs", "Rivets & Nails"],
        span: "md:col-span-1",
    },
    {
        slug: "safety",
        name: "Safety & PPE",
        label: "Safety Gear",
        Icon: HardHat,
        image:
            "https://images.pexels.com/photos/8488037/pexels-photo-8488037.jpeg",
        description:
            "Helmets, gloves, safety goggles, harnesses and hi-vis jackets built for site work.",
        items: ["Helmets & Goggles", "Work Gloves", "Safety Shoes", "Hi-Vis Jackets"],
        span: "md:col-span-2",
    },
];
